import { motion } from "framer-motion";
import React, { useContext, useRef, useState } from "react";
import Container from "react-bootstrap/Container";
import VisibilitySensor from "react-visibility-sensor";
import audioImg from "../../assets/images/exp_audio.jpg";
import c64Img from "../../assets/images/exp_c64.jpg";
import codePlayground from "../../assets/images/exp_code.jpg";
import coffeeImg from "../../assets/images/exp_coffee.jpg";
import osImg from "../../assets/images/exp_os.jpg";
import terminalImg from "../../assets/images/exp_terminal.jpg";
import videoImg from "../../assets/images/exp_video.jpg";
import webEditor from "../../assets/images/exp_webeditor.jpg";
import { Context } from "../../context";
import classes from "./Experiments.module.css";
import ExperimentsCard from "./ExperimentsCard";

const Experiments = () => {
  const [overlay, setOverlay] = useState(false);
  const demoSectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const { debug, lang, terminal, setTerminal, setViewMode } =
    useContext(Context);

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  const experiments = [
    {
      id: 1,
      title: "Terminal",
      img: terminalImg,
      github: "https://github.com/davidebalice/react-terminal-emulator",
      github2: "https://github.com/davidebalice/node-file-system-api",
    },
    {
      id: 2,
      title: "Os interface",
      img: osImg,
      github: "https://github.com/davidebalice/react-os-interface",
      github2: "https://github.com/davidebalice/node-file-system-api",
    },
    {
      id: 3,
      title: "Web editor",
      img: webEditor,
      github: "https://github.com/davidebalice/react-website-editor-prototype",
    },

    {
      id: 8,
      title: "Code playground",
      img: codePlayground,
      github: "https://github.com/davidebalice/code-playground",
    },

    {
      id: 4,
      title: "Coffee break",
      img: coffeeImg,
      github: "",
    },
    {
      id: 5,
      title: "Audio player",
      img: audioImg,
      github: "https://github.com/davidebalice/audio-player",
    },
    {
      id: 6,
      title: "Video player",
      img: videoImg,
      github: "https://github.com/davidebalice/video-player",
    },
    {
      id: 7,
      title: "C64",
      img: c64Img,
      github: "",
    },
  ];

  return (
    <>
      {overlay && <div className={classes.overlay}></div>}
      <section id="demoHome" className={`${classes.demoHome} section p_zero`}>
        <div className="text-center py-5">
          <div className="container">
            <VisibilitySensor
              onChange={changeVisibility}
              partialVisibility
              delayedCall
            >
              <motion.p
                initial={{ opacity: 0, y: 12 }}
                animate={{
                  opacity: isVisible ? 1 : 0,
                }}
                transition={{ duration: 0.4, delay: 0.65 }}
                className={`text-4 text-dark w-100 align-self-center text-start lh-base mb-0 mt-1 m-auto ${classes.demoText}`}
              >
                {lang === "en" && (
                  <>
                    In this section of the website, there are{" "}
                    <b>some experiments</b>: examples of interfaces, media
                    player and games.
                    <br />
                    <b>Terminal</b> is a real terminal, allowing navigation
                    through the server's file system via text commands.
                    <br />
                    <b>Os</b> is an app that recreates the design of an{" "}
                    <b>operating system</b> similar to Windows, with a system of{" "}
                    <b>multiple windows</b> that can be moved, resized, or
                    minimized, ideal for having multiple pieces of information
                    open simultaneously.
                    <br />
                    There is also an <b>audio player</b>, <b>video player</b>{" "}
                    and a <b>gaming hub</b>.
                  </>
                )}
                {lang === "it" && (
                  <>
                    In questa sezione del sito web sono presenti{" "}
                    <b>alcuni esperimenti:</b> esempi di interfacce, media
                    player e giochi.
                    <br />
                    <b>Terminal</b> è un vero <b>terminale</b>, che consente di
                    navigare tra il <b>file system</b> del server tramite
                    comandi testuali.
                    <br />
                    <b>Os</b> è un app che ripropone il design di un{" "}
                    <b>sistema operativo</b> simile a Windows, con un sistema di{" "}
                    <b>finestre multiple</b> che possono essere spostate,
                    ridimensionate o ridotte a icona, ideale per avere più
                    informazioni aperte contemporaneamente.
                    <br />
                    E' presente inoltre un <b>audio player</b>,{" "}
                    <b>video player</b> ed un <b>gaming hub</b>.
                  </>
                )}

                <br />
              </motion.p>
            </VisibilitySensor>
          </div>
        </div>
        <Container
          ref={demoSectionRef}
          fluid
          className={`${classes.demoCardContainer} text-center`}
        >
          <div className={`${classes.topLinea}`}></div>

          <div className="row gx-4 mx-lg-4 demo">
            {experiments.map((item) => (
              <>
                <ExperimentsCard
                  key="ddd"
                  card={item}
                  delay={2}
                  terminal={terminal}
                  setTerminal={setTerminal}
                  setViewMode={setViewMode}
                />
              </>
            ))}
          </div>
        </Container>
      </section>
    </>
  );
};

export default Experiments;
